import Emitter from '@resources/js/helpers/Emitter'
import { addDay } from "@formkit/tempo"

export default class FormStore extends Emitter {
    #data

    constructor() {
        super()
        this.#data = {
            checkIn: addDay(new Date(), 1),
            checkOut: addDay(new Date(), 2),
        }
    }

    getData() {
        return this.#data
    }

    getProperty(name) {
        return this.#data[name]
    }

    setProperty(name, value) {
        if (this.#data[name] === value) return
        this.#updateProperty(name, value)
    }

    #updateProperty(name, value) {
        this.#data[name] = value
        this.emit('change', { name, value })
    }
}
